import { module_names } from "./ModuleNamesInDB";
import { RouteInfo } from "./sidebar.metadata";

export const ROUTES: RouteInfo[] = [
  {
    path: "/AdminPanel/home",
    title: "Home",
    icon: "mdi mdi-view-dashboard",
    class: "",
    extralink: false,
    submenu: [],
    moduleName: module_names.home_module,
  },
  {
    path: "/AdminPanel/accounting",
    title: "Sales & Accounting",
    icon: "mdi mdi-view-dashboard",
    class: "",
    extralink: false,
    submenu: [],
    moduleName: module_names.account_module,
  },
  {
    path: "/AdminPanel/users",
    title: "User Data",
    icon: "mdi mdi-account-multiple",
    class: "",
    extralink: false,
    moduleName: module_names.user_module,
    submenu: [
      {
        path: "/AdminPanel/users",
        title: "Users",
        icon: "mdi mdi-account-multiple",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.user_module,
      },
      {
        path: "/AdminPanel/register-user",
        title: "Customer Users",
        icon: "mdi mdi-account-multiple",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.customers_module,
      },
      {
        path: "/AdminPanel/roles",
        title: "User Roles",
        icon: "mdi mdi-view-dashboard",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.role_module,
      },
    ]
  },
  // {
  //   path: "/AdminPanel/users",
  //   title: "Users",
  //   icon: "mdi mdi-account-multiple",
  //   class: "",
  //   extralink: false,
  //   submenu: [],
  //   moduleName: module_names.user_module,
  // },
  // {
  //   path: "/AdminPanel/register-user",
  //   title: "Customer Users",
  //   icon: "mdi mdi-account-multiple",
  //   class: "",
  //   extralink: false,
  //   submenu: [],
  //   moduleName: module_names.customers_module,
  // },
  // {
  //   path: "/AdminPanel/roles",
  //   title: "Roles",
  //   icon: "mdi mdi-view-dashboard",
  //   class: "",
  //   extralink: false,
  //   submenu: [],
  //   moduleName: module_names.role_module,
  // },
  {
    path: "/AdminPanel/booking-calender",
    title: "Global Calendar",
    icon: "mdi mdi-calendar-text",
    class: "",
    extralink: false,
    submenu: [],
    moduleName: module_names.bookingcalender_module,
  },
  {
    path: "/AdminPanel/sites",
    title: "Site Data",
    icon: "mdi mdi-sitemap",
    class: "",
    extralink: false,
    moduleName: module_names.site_module,
    submenu: [
      {
        path: "/AdminPanel/sites",
        title: "Sites",
        icon: "mdi mdi-sitemap",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.site_module,
      },
      {
        path: "/AdminPanel/site-group",
        title: "Site Groups",
        icon: "mdi mdi-sitemap",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.SiteGroup_module,
      },
      {
        path: "/AdminPanel/hires-images",
        title: "HiRes Images",
        icon: "mdi mdi-sitemap",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.SiteGroup_module,
      },
      {
        path: "/AdminPanel/proofcard-listing",
        title: "Proofcards",
        icon: "mdi mdi-sitemap",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.SiteGroup_module,
      },
      {
        path: "/AdminPanel/proofcard-generator",
        title: "Proofcard Generator",
        icon: "mdi mdi-sitemap",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.SiteGroup_module,
      },
    ]
  },
  // {
  //   path: "/AdminPanel/sites",
  //   title: "Sites",
  //   icon: "mdi mdi-sitemap",
  //   class: "",
  //   extralink: false,
  //   submenu: [],
  //   moduleName: module_names.site_module,
  // },
  // {
  //   path: "/AdminPanel/site-group",
  //   title: "Site Groups",
  //   icon: "mdi mdi-sitemap",
  //   class: "",
  //   extralink: false,
  //   submenu: [],
  //   moduleName: module_names.SiteGroup_module,
  // },
  {
    path: "/AdminPanel/orders-new",
    title: "Order Data",
    icon: "fab fa-first-order",
    class: "",
    extralink: false,
    moduleName: module_names.order_module,
    submenu: [
      {
        path: "/AdminPanel/orders-new",
        title: "Global Orders",
        icon: "fab fa-first-order",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.order_module,
      },
      {
        path: "/AdminPanel/manage-order",
        title: "Global Orders Old",
        icon: "fab fa-first-order",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.order_module,
      },

      {
        path: "/AdminPanel/order-archive",
        title: "Orders Archive",
        icon: "fab fa-first-order",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.order_module,
      },

      {
        path: "/AdminPanel/create-edit-orders",
        title: "Create/Edit Orders",
        icon: "mdi mdi-sale",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.CreateEditOrder,
      },
      {
        path: "/AdminPanel/order-status",
        title: "Order Status",
        icon: "mdi mdi-calendar-question",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.OrderStatus_module,
      },
      {
        path: "/AdminPanel/serach-order-status",
        title: "Search Order Status",
        icon: "mdi mdi-account-search",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.SearchOrderStatus_module,
      },
    ]
  },
  // {
  //   path: "/AdminPanel/manage-order",
  //   title: "Global Orders",
  //   icon: "fab fa-first-order",
  //   class: "",
  //   extralink: false,
  //   submenu: [],
  //   moduleName: module_names.order_module,
  // },
  // {
  //   path: "/AdminPanel/manage-order",
  //   title: "Global Orders New",
  //   icon: "fab fa-first-order",
  //   class: "",
  //   extralink: false,
  //   submenu: [],
  //   moduleName: module_names.order_module,
  // },
  // {
  //   path: "/AdminPanel/create-edit-orders",
  //   title: "Create/Edit Orders",
  //   icon: "mdi mdi-sale",
  //   class: "",
  //   extralink: false,
  //   submenu: [],
  //   moduleName: module_names.CreateEditOrder,
  // },
  // {
  //   path: "/AdminPanel/order-status",
  //   title: "Order Status",
  //   icon: "mdi mdi-calendar-question",
  //   class: "",
  //   extralink: false,
  //   submenu: [],
  //   moduleName: module_names.OrderStatus_module,
  // },
  // {
  //   path: "/AdminPanel/serach-order-status",
  //   title: "Search Order Status",
  //   icon: "mdi mdi-account-search",
  //   class: "",
  //   extralink: false,
  //   submenu: [],
  //   moduleName: module_names.SearchOrderStatus_module,
  // },

  {
    path: "/AdminPanel/commission-template",
    title: "Commission",
    icon: "mdi mdi mdi-cash-100",
    class: "",
    extralink: false,
    submenu: [],
    moduleName: module_names.commissiontemplate_module,
  },

  // {
  //   path: "/AdminPanel/old-website-orders",
  //   title: "Older Orders",
  //   icon: "mdi mdi-av-timer",
  //   class: "",
  //   extralink: false,
  //   submenu: [],
  //   moduleName: module_names.OlderOrders_module,
  // },
  // {
  //   path: "/AdminPanel/old-website-search-orders",
  //   title: "Older Search Orders",
  //   icon: "mdi mdi-av-timer",
  //   class: "",
  //   extralink: false,
  //   submenu: [],
  //   moduleName: module_names.OlderSearchOrders_module,
  // },
  // {
  //   path: '/AdminPanel/manager-orders',
  //   title: 'manager Orders',
  //   icon: 'fab fa-first-order',
  //   class: '',
  //   extralink: false,
  //   submenu: [],
  //   moduleName: module_names.order_module
  // },
  {
    path: "/AdminPanel/product-list",
    title: "Product Builder",
    icon: "icon-Shopping-Bag",
    class: "",
    extralink: false,
    moduleName: module_names.product_module,
    submenu: [
      {
        path: "/AdminPanel/product-list",
        title: "Product List",
        icon: "mdi mdi-account-multiple",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.product_module,
      },
      {
        path: "/AdminPanel/product-templates",
        title: "Templates",
        icon: "mdi mdi-account-multiple",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.template_module,
      },

      {
        path: "/AdminPanel/product-categories",
        title: "Product Categories",
        icon: "mdi mdi-account-multiple",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.categories_module,
      },
      {
        path: "/AdminPanel/store-categories",
        title: "Store Categories",
        icon: "mdi mdi-store",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.categories_module,
      },
      // {
      //   path: '/AdminPanel/product-sizeordering',
      //   title: 'Size Ordering',
      //   icon: 'mdi mdi-account-multiple',
      //   class: '',
      //   extralink: false,
      //   submenu: [],
      //   moduleName: module_names.sizeorder_module
      // },
      {
        path: "/AdminPanel/product-bannersAndOffers",
        title: "Offers",
        icon: "mdi mdi-account-multiple",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.banner_module,
      },
      {
        path: "/AdminPanel/product-export",
        title: "Product Export",
        icon: "mdi mdi-account-multiple",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.productExport_module,
      },
    ],
  },
  {
    path: "/AdminPanel/vouchers",
    title: "Vouchers",
    icon: "mdi mdi-wallet-giftcard",
    class: "",
    extralink: false,
    submenu: [],
    moduleName: module_names.voucher_module,
  },
  {
    path: "/AdminPanel/portfolio",
    title: "Portfolio",
    icon: "fas fa-briefcase",
    class: "",
    extralink: false,
    submenu: [],
    moduleName: module_names.portfolio_module,
  },
  {
    path: "/AdminPanel/news-letter",
    title: "News Letters",
    icon: "mdi mdi-newspaper",
    class: "",
    extralink: false,
    submenu: [],
    moduleName: module_names.newsletter_module,
  },
  {
    path: "/AdminPanel/subscribers",
    title: "Children's Promotional Subscribers",
    icon: "fa fa-tag",
    class: "",
    extralink: false,
    submenu: [],
    moduleName: module_names.subscriber_module,
  },
  {
    path: "/AdminPanel/gdprLog",
    title: "G.D.P.R.  Audit Log",
    icon: "mdi mdi-verified",
    class: "",
    extralink: false,
    submenu: [],
    moduleName: module_names.gdprLog_module,
  },
  {
    path: "/AdminPanel/FTP-drop-zone",
    title: "FTP Drop zone",
    icon: "mdi mdi-dropbox",
    class: "",
    extralink: false,
    submenu: [],
    moduleName: module_names.ftpDropZone_module,
  },
  // {
  //   path: "/AdminPanel/home",
  //   title: "Static Pages",
  //   icon: "icon-Files",
  //   class: "",
  //   extralink: false,
  //   moduleName: module_names.pages_module,
  //   submenu: [
  //     {
  //       path: "/AdminPanel/FAQ",
  //       title: "FAQS Parents",
  //       icon: "",
  //       class: "",
  //       extralink: false,
  //       submenu: [],
  //       moduleName: module_names.parentfaqspage_module,
  //     },
  //     {
  //       path: "/AdminPanel/FAQ-nurserys",
  //       title: "FAQS Nursery",
  //       icon: "",
  //       class: "",
  //       extralink: false,
  //       submenu: [],
  //       moduleName: module_names.nurseryfaqspage_module,
  //     },
  //     {
  //       path: "/AdminPanel/proofcard-account",
  //       title: "Proofcard Account",
  //       icon: "",
  //       class: "",
  //       extralink: false,
  //       submenu: [],
  //       moduleName: module_names.nurseryfaqspage_module,
  //     },
  //     {
  //       path: "/AdminPanel/GDPR-policy",
  //       title: "GDPR Policy",
  //       icon: "",
  //       class: "",
  //       extralink: false,
  //       submenu: [],
  //       moduleName: module_names.pages_module,
  //     },
  //     {
  //       path: "/AdminPanel/vacancies",
  //       title: "Vacancies",
  //       icon: "",
  //       class: "",
  //       extralink: false,
  //       submenu: [],
  //       moduleName: module_names.vacanciespage_module,
  //     },
  //     {
  //       path: "/AdminPanel/policy",
  //       title: "Terms and Conditions",
  //       icon: "",
  //       class: "",
  //       extralink: false,
  //       submenu: [],
  //       moduleName: module_names.termsncondition_module,
  //     },
  //     {
  //       path: "/AdminPanel/order",
  //       title: "Order",
  //       icon: "",
  //       class: "",
  //       extralink: false,
  //       submenu: [],
  //       moduleName: module_names.orderpage_module,
  //     },

  //     // {
  //     //   path: '/AdminPanel/news-letter',
  //     //   title: 'News Letters',
  //     //   icon: 'mdi mdi-account-multiple',
  //     //   class: '',
  //     //   extralink: false,
  //     //   submenu: [],
  //     //   moduleName: module_names.newsletter_module
  //     // },
  //     {
  //       path: "/AdminPanel/commision",
  //       title: "Commission",
  //       icon: "",
  //       class: "",
  //       extralink: false,
  //       submenu: [],
  //       moduleName: module_names.comissionpage_module,
  //     },
  //     {
  //       path: "/AdminPanel/pictures",
  //       title: "Class & Team Pictures",
  //       icon: "",
  //       class: "",
  //       extralink: false,
  //       submenu: [],
  //       moduleName: module_names.classnteampic_module,
  //     },
  //     {
  //       path: "/AdminPanel/work",
  //       title: "How we work",
  //       icon: "",
  //       class: "",
  //       extralink: false,
  //       submenu: [],
  //       moduleName: module_names.howwework_module,
  //     },
  //     {
  //       path: "/AdminPanel/coockies",
  //       title: "What are cookies?",
  //       icon: "",
  //       class: "",
  //       extralink: false,
  //       submenu: [],
  //       moduleName: module_names.whatarecookie_module,
  //     },
  //     {
  //       path: "/AdminPanel/nurseryNschools",
  //       title: "Nursery and Schools",
  //       icon: "",
  //       class: "",
  //       extralink: false,
  //       submenu: [],
  //       moduleName: module_names.nurserynschool_module,
  //     },
  //     {
  //       path: "/AdminPanel/older-groups",
  //       title: "Older Groups",
  //       icon: "",
  //       class: "",
  //       extralink: false,
  //       submenu: [],
  //       moduleName: module_names.oldergrouppage_module,
  //     },
  //     {
  //       path: "/AdminPanel/nursory-manager-login",
  //       title: "Nursery Manager Login",
  //       icon: "",
  //       class: "",
  //       extralink: false,
  //       submenu: [],
  //       moduleName: module_names.nurserymanager_module,
  //     },
  //     // {
  //     //   path: "/AdminPanel/footer",
  //     //   title: "Footer",
  //     //   icon: "",
  //     //   class: "",
  //     //   extralink: false,
  //     //   submenu: [],
  //     //   moduleName: module_names.footerpage_module,
  //     // },
  //   ],
  // },
  {
    path: "/AdminPanel/settings",
    title: "Settings",
    icon: "mdi mdi-settings-box",
    class: "",
    extralink: false,
    submenu: [],
    moduleName: module_names.paymentsetting_module,
  },

  // {
  //   path: "/AdminPanel/proofcard-listing",
  //   title: "Customer Proofcards",
  //   icon: "mdi mdi-cards",
  //   class: "",
  //   extralink: false,
  //   submenu: [],
  //   moduleName: module_names.proofcardlisting_module,
  // },

  // {
  //   path: "/AdminPanel/bulk-uploder",
  //   title: "Bulk Uploder",
  //   icon: "mdi mdi-verified",
  //   class: "",
  //   extralink: false,
  //   submenu: [],
  //   moduleName: module_names.bulkuploder_module,
  // },
];
